<template>
<div style="text-align: left;">
  {{loading}}
</div>
</template>

<script>
  import {HTTP} from '../core/http/http-common';
  import Routing from '../core/router/router';
    export default {
        name: "statut-update",
      data(){
          return{
            loading : ''
          }
      },
      methods : {
          changeState(){
            var self = this;
            HTTP.post(
              Routing.generate("api_configuration_post_edit_alive_rmbox",
                {id: this.$route.params.id}))
              .then(
                function(response){
              console.log(response);
                  self.loading = response.data
            },function(error){
              console.log(error)
                  self.loading = error
            })
          }
      },
      mounted(){
        this.changeState();
      }
    }
</script>

<style scoped lang="scss">
  .wrapper-update{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70%;
    font-size: 4rem;
    color: #5cb85c;

  }
</style>



// WEBPACK FOOTER //
// src/components/statusUpdate.vue